import Vue from "vue";
import i18n from "./lang";

import App from "./App";
import router from "./router";
import store from "./store";
import Buefy from "buefy";
import VTooltip from "v-tooltip";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import VModal from "vue-js-modal";
import VueTimepicker from "vue2-timepicker";
import VuePapaParse from "vue-papa-parse";
import VueClipboard from "vue-clipboard2";
import wysiwyg from "vue-wysiwyg";

// Automatically loads environment variables
require("dotenv").config();

Vue.use(VueClipboard);
Vue.use(wysiwyg, {
  hideModules: {
    image: true,
    code: true,
  },
});
Vue.use(VuePapaParse);
// PrimeVue Imports
import "primeflex/primeflex.css";
import UpgradeBanner from "@/components/UpgradeBanner";
import Ball from "@/components/Ball";
import Uppy from "@/components/Uppy";
import PapaParse from "@/components/PapaParse";
import Breadcrumbs from "@/components/Breadcrumbs";
import Cal from "@/components/Cal";
import PersonForm from "@/components/PersonForm";
import Reschedule from "@/components/Reschedule";
import InputNumber from "primevue/inputnumber";
import InputText from "primevue/inputtext";
import InputMask from "primevue/inputmask";
import Dialog from "primevue/dialog";
// import OverlayPanel from 'primevue/overlaypanel';
import Button from "primevue/button";
import Checkbox from "primevue/checkbox";
import RadioButton from "primevue/radiobutton";
import ProgressBar from "primevue/progressbar";
import ProgressSpinner from "primevue/progressspinner";
import Dropdown from "primevue/dropdown";
import MultiSelect from "primevue/multiselect";
import Sidebar from "primevue/sidebar";
import Menu from "primevue/menu";
import TieredMenu from "primevue/panelmenu";
import api from "@/api";
import { Compact } from "vue-color";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
//import Panel from "primevue/panel";
import { Datetime } from "vue-datetime";
// You need a specific loader for CSS files
import "vue-datetime/dist/vue-datetime.css";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import VueConfetti from "vue-confetti";
import VueMeta from "vue-meta";

Vue.use(VueConfetti);
Vue.use(VueMeta);
Vue.use(Datetime);
Vue.use(ToastService);

Vue.component("Uppy", Uppy);
Vue.component("Ball", Ball);
Vue.component("Reschedule", Reschedule);
Vue.component("InputText", InputText);
Vue.component("InputMask", InputMask);
Vue.component("UpgradeBanner", UpgradeBanner);
Vue.component("PapaParse", PapaParse);
Vue.component("InputNumber", InputNumber);
Vue.component("Dialog", Dialog);
Vue.component("Button", Button);
Vue.component("RadioButton", RadioButton);
Vue.component("ProgressBar", ProgressBar);
Vue.component("ProgressSpinner", ProgressSpinner);
Vue.component("TimePicker", VueTimepicker);
Vue.component("Dropdown", Dropdown);
Vue.component("Accordion", Accordion);
Vue.component("AccordionTab", AccordionTab);
Vue.component("MultiSelect", MultiSelect);
Vue.component("Sidebar", Sidebar);
Vue.component("Menu", Menu);
Vue.component("TieredMenu", TieredMenu);
Vue.component("Checkbox", Checkbox);
Vue.component("Picker", Compact);
Vue.component("Toast", Toast);
Vue.component("Cal", Cal);
//Vue.component("Panel", Panel);
// Vue.component('DatePicker', Datepicker)
Vue.component("PersonForm", PersonForm);
Vue.component("datetime", Datetime);

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faArrowLeft,
  faPlus,
  faArrowDown,
  faUserFriends,
  faStream,
  faLayerGroup,
  faUserAlt,
} from "@fortawesome/free-solid-svg-icons";

import {
  faCopy,
  faFileAlt,
  faHandPeace,
  faUndo,
  faHandPointer,
  faLockAlt,
  faUserSecret,
  faQuestionCircle,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faPlay,
  faCheckCircle,
  faCalendar,
  faArrowToTop,
  faCalendarAlt,
  faClipboardList,
  faAngleDown,
  faTrashAlt,
  faUsers,
  faArrowUp,
  faClock,
  faTimesCircle,
  faBallPile,
  faAward,
  faBrowser,
  faEdit,
} from "@fortawesome/pro-light-svg-icons";
import {
  faHomeAlt,
  faAngleUp,
  faMapMarkerAlt,
  faCog,
  faGem,
  faPennant,
  faChartNetwork,
  faUser,
  faInfo,
  faInfoCircle,
  faTrophy,
} from "@fortawesome/pro-light-svg-icons";

import { faRankingStar, faXmark, faTableTree } from "@fortawesome/pro-thin-svg-icons";

library.add(
  faPlus,
  faPlay,
  faCopy,
  faArrowToTop,
  faTimesCircle,
  faUsers,
  faBallPile,
  faLockAlt,
  faHomeAlt,
  faCheckCircle,
  faCalendar,
  faCalendarAlt,
  faArrowLeft,
  faClock,
  faCog,
  faUserFriends,
  faMapMarkerAlt,
  faUserSecret,
  faClipboardList,
  faCalendarAlt,
  faAngleDown,
  faAngleUp,
  faLayerGroup,
  faStream,
  faUserAlt,
  faArrowDown,
  faArrowUp,
  faGem,
  faHandPointer,
  faUndo,
  faHandPeace,
  faTrashAlt,
  faFileAlt,
  faPennant,
  faChartNetwork,
  faUser,
  faInfo,
  faInfoCircle,
  faRankingStar,
  faQuestionCircle,
  faXmark,
  faAward,
  faTrophy,
  faBrowser,
  faEdit,
  faTableTree,
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

// import 'buefy/dist/buefy.css'
import "./assets/primevue-v2.css";
import "./assets/main.scss";
import "./assets/sign.scss";
import "./assets/pricing.scss";
import "vue-wysiwyg/dist/vueWysiwyg.css";

import "leaflet/dist/leaflet.css";
import "vue2-timepicker/dist/VueTimepicker.css";

import VueHtmlToPaper from "vue-html-to-paper";
const options = {
  specs: ["fullscreen=yes"],
  styles: [
    "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    "https://diamond-public.s3.us-west-2.amazonaws.com/resources/table.css",
  ],
};
Vue.use(VueHtmlToPaper, options);

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("breadcrumbs", Breadcrumbs);

require("vue2-animate/dist/vue2-animate.min.css");

Vue.config.devtools = false;

Vue.config.productionTip = false;
Vue.use(Buefy, { defaultIconPack: "fas" });
// Vue.use(Toasted, { position: 'top-center', duration: 5000 })
Vue.use(VTooltip);
Vue.use(VModal);

import AirbnbStyleDatepicker from "vue-airbnb-style-datepicker";
import "vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css";

var sf = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).first_day != 1 : true;
// this.sayDev("SF: " + sf, localStorage.getItem("user"))
// see docs for available options
const datepickerOptions = {
  colors: {
    selected: "#ec0838",
    inRange: "#ec0838",
    selectedText: "#FFFFFF",
    hoveredInRange: "#d3d3d3",
    inRangeBorder: "#d3d3d3",
  },
  sundayFirst: sf,
};

// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions);

Vue.mixin({
  // dddd
  data: function() {
    return {
      apiUrl: window.location.href.includes("localhost") ? "http://localhost:8080" : process.env.VUE_APP_API_URL,
      isDebug: window.location.href.includes("debug") || window.location.href.includes("localhost"),
      paidUser: false,
      lastRoute: null,
      baseURL: process.env.VUE_APP_BASE_URL || "http://localhost:3000",
      landingPageURL: process.env.VUE_APP_LANDING_PAGE_URL || "http://localhost:5000" || "https://cactusware.com/",
      oldColorPalette: [
        "#000000",
        "#e6194b",
        "#3cb44b",
        "#ffe119",
        "#4363d8",
        "#f58231",
        "#911eb4",
        "#46f0f0",
        "#f032e6",
        "#bcf60c",
        "#fabebe",
        "#008080",
        "#e6beff",
        "#9a6324",
        "#fffac8",
        "#800000",
        "#aaffc3",
        "#808000",
        "#ffd8b1",
        "#000075",
        "#808080",
      ],
      sportIds: [
        { id: 1, name: "Ice Hockey" },
        { id: 3, name: "Lacrosse" },
        { id: 4, name: "Baseball / Softball" },
        { id: 5, name: "Soccer" },
        { id: 6, name: "Cycling" },
        { id: 7, name: "Basketball" },
        { id: 9, name: "Track and Field" },
        { id: 10, name: "Tennis" },
        { id: 11, name: "Football" },
        { id: 12, name: "Volleyball" },
        { id: 13, name: "Wrestling" },
        { id: 16, name: "Rugby Union" },
        { id: 18, name: "Golf" },
        { id: 20, name: "Paintball" },
        { id: 21, name: "Cross Country" },
        { id: 22, name: "Swimming" },
        { id: 23, name: "Skiing" },
        { id: 24, name: "Basic" },
        { id: 25, name: "Rugby Wheelchair" },
        { id: 26, name: "Canadian Football" },
        { id: 27, name: "Other" },
        { id: 28, name: "Water Polo" },
      ],
    };
  },
  computed: {
    isAdmin() {
      return (
        this.currentUser &&
        [
          "jhall@cactusware.com",
          "brett@cactusware.com",
          "john@aluminum.io",
          "jonathan@siegel.io",
          "zahar@aluminum.io",
          process.env.VUE_APP_SYS_ADMIN,
        ].includes(this.currentUser.email)
      );
    },
    timeOptions() {
      var results = [];
      var i = 0;
      while (i < 1440) {
        const f = this.$moment.utc(i * 60000).format("HH:mm");
        var str = i < 720 ? f + " AM" : f + " PM";
        var formatted = str;
        if (str.charAt(0) == "0") {
          formatted = str.substring(1);
        }
        var first = formatted.charAt(0) + formatted.charAt(1);
        if (first == "0:") {
          formatted = "12" + formatted.substring(1);
        } else if (first == "13") {
          formatted = "1" + formatted.substring(2);
        } else if (first == "14") {
          formatted = "2" + formatted.substring(2);
        } else if (first == "15") {
          formatted = "3" + formatted.substring(2);
        } else if (first == "16") {
          formatted = "4" + formatted.substring(2);
        } else if (first == "17") {
          formatted = "5" + formatted.substring(2);
        } else if (first == "18") {
          formatted = "6" + formatted.substring(2);
        } else if (first == "19") {
          formatted = "7" + formatted.substring(2);
        } else if (first == "20") {
          formatted = "8" + formatted.substring(2);
        } else if (first == "21") {
          formatted = "9" + formatted.substring(2);
        } else if (first == "22") {
          formatted = "10" + formatted.substring(2);
        } else if (first == "23") {
          formatted = "11" + formatted.substring(2);
        }
        results.push({
          label: formatted,
          text: str,
          raw: f + ":00",
        });
        i += 5;
      }
      return results;
    },
    currentSeasonSurfaces() {
      var x = [];
      this.currentSeason.venues.forEach(v => {
        v.surfaces.forEach(s => {
          var g = Object.assign({}, s);
          g.venue = v;
          x.push(g);
        });
      });
      return x;
    },
    noLeagues() {
      return !this.$store.getters.leagueInformation || this.$store.getters.leagueInformation.length == 0;
    },
    primaryPallette() {
      return [
        "#E90038",
        "#AD1457",
        "#8E24AA",
        "#4527A0",
        "#7E57C2",
        "#1565C0",
        "#03A9F4",
        "#00B8D4",
        "#00796B",
        "#388E3C",
        "#8BC34A",
        "#AFB42B",
        "#FDD835",
        "#FFB300",
        "#F57C00",
        "#F4511E",
        "#795548",
        "#7B7565",
        "#757575",
        "#607D8B",
        "#AEEA00",
        "#2962FF",
        "#00E5FF",
        "#00BFA5",
        "#00C853",
        "#F50057",
      ];
    },
    secondaryPallette() {
      return [
        "#FF8A80",
        "#F8BBD0",
        "#E1BEE7",
        "#B39DDB",
        "#9FA8DA",
        "#90CAF9",
        "#B3E5FC",
        "#80DEEA",
        "#B2DFDB",
        "#A5D6A7",
        "#DCEDC8",
        "#E6EE9C",
        "#FFF59D",
        "#FFE082",
        "#FFCC80",
        "#FFAB91",
        "#D7CCC8",
        "#BCAAA4",
        "#BDBDBD",
        "#B0BEC5",
        "#CCFF90",
        "#80D8FF",
        "#18FFFF",
        "#64FFDA",
        "#69F0AE",
        "#FF80AB",
      ];
    },
    currentUser() {
      return this.$store.getters.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    currentOrganization() {
      return this.$store.getters.currentOrganization;
    },
    currentLeague() {
      return this.$store.getters.currentLeague;
    },
    currentSeason() {
      return this.$store.getters.currentSeason;
    },
    seConnected() {
      if (
        this.currentUser &&
        this.currentUser.organization.id == this.currentOrganization.id &&
        !!this.currentUser.organization.se_access
      ) {
        return true;
      }
      return false;
    },
    orgOwner() {
      if (
        this.currentUser &&
        this.currentUser.organization.id == this.currentOrganization.id &&
        this.currentUser.org_owner
      ) {
        return true;
      }
      return false;
    },
    jpLocale() {
      if ((this.currentUser && this.currentUser.locale == "ja") || this.$i18n.locale == "ja") {
        return true;
      }
      return false;
    },
    isProduction() {
      return !window.location.href.includes("localhost");
    },
    leagueInfo() {
      var leagues = [];
      var seasons = [];
      var currentSeasons = [];

      var l = this.$store.getters.leagueInformation;
      l.forEach(league => {
        leagues.push({
          label: league.name,
          value: league.id,
        });
        league.seasons.forEach(season => {
          seasons.push({
            label: season.name,
            value: season.id,
          });
        });
        if (league.id == this.$store.getters.currentLeague.id) {
          league.seasons.forEach(season => {
            currentSeasons.push({
              label: season.name,
              value: season.id,
            });
          });
        }
      });
      this.sayDev("LeagueInfo", {
        leagues: leagues,
        seasons: seasons,
        currentLeagueSeasons: currentSeasons,
      });
      return {
        leagues: leagues,
        seasons: seasons,
        currentLeagueSeasons: currentSeasons,
      };
    },
  },
  methods: {
    formattedSeconds: function(seconds) {
      if (seconds < 0 || seconds == undefined) {
        return "";
      }
      var date = new Date(seconds * 1000);
      var hh = date.getUTCHours();
      var mm = date.getUTCMinutes();
      var ss = date.getSeconds();

      if (hh > 0) {
        hh = hh + ":";
      } else {
        hh = "";
      }
      if (mm < 10 && mm != 0) {
        if (hh == "") {
          mm = mm + ":";
        } else {
          mm = "0" + mm + ":";
        }
      } else if (mm > 10) {
        mm = mm + ":";
      } else if (mm == 0 || mm == 10) {
        mm = mm + ":";
      }
      if (ss < 10) {
        ss = "0" + ss;
      }
      // This formats your string to HH:MM:SS
      return hh + mm + ss;
    },
    wrap(str) {
      if (!str) {
        return "";
      }
      return '"' + str.toString().replace(/\#/g, "") + '"';
    },
    convertArrayOfObjectsToCSV: function(args) {
      console.log("convertin", args);
      // console.log(args);
      var result, ctr, keys, columnDelimiter, lineDelimiter, data;

      data = args.data;
      // console.log(args);
      if (data == null || !data.length) {
        return null;
      }

      columnDelimiter = args.columnDelimiter || ",";
      lineDelimiter = args.lineDelimiter || "\n";

      keys = Object.keys(data[0]);

      result = "";
      result += keys.join(columnDelimiter);
      result += lineDelimiter;
      // if(gon.isProduction) {
      //   window.bento.track("Download Leads CSV");
      // }
      data.forEach(function(item) {
        ctr = 0;
        keys.forEach(function(key) {
          if (ctr > 0) result += columnDelimiter;

          result += item[key];
          ctr++;
        });
        result += lineDelimiter;
      });
      this.sayDev("RESULT!", result);
      return result;
    },
    // sdsd
    sayDev(str, obj) {
      if (window.location.href.includes("debug") || !this.isProduction) {
        if (obj) {
          console.log(str, obj);
        } else {
          console.log(str);
        }
      }
    },
    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      } else {
        return true;
      }
    },
    dateToMDY(date) {
      var date = new Date(date);
      return (
        (date.getMonth() > 8 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1)) +
        "/" +
        (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) +
        "/" +
        date.getFullYear()
      );
    },
    setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    },
    getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },
    eraseCookie(name) {
      document.cookie = name + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    },
    exportSchedule(schedule) {
      if (!this.currentUser.upgraded) {
        alert("Please upgrade your account to export to SportsEngine!");
        return;
      }
      this.trackEvent("Started SportsEngine Export", { schedule: schedule });
      var x = window.confirm(
        "You're about to send the schedule '" +
          schedule.name +
          "' with " +
          schedule.scheduled +
          " games to SportsEngine. Press OK to continue or cancel to not proceed.",
      );
      if (x) {
        this.trackEvent("Confirmed SportsEngine Export", {
          schedule: schedule,
        });

        if (this.$route.query.type === "season") {
          api.exportScheduleSportsEngineBeta(schedule.id).then(response => {
            this.goRouter(`/activity/${response.data.activity.id}`);
          });
        } else {
          api
            .exportScheduleSportsengine(schedule.id, {
              organization_id: this.$store.getters.currentOrganization
                ? this.$store.getters.currentOrganization.id
                : {},
            })
            .then(response => {
              this.sayDev(response);
              if (this.isProduction) {
                this.goRouter(`/activity/${response.data.activity.id}`);
              }
            })
            .catch(e => {
              this.makeToast("error", "Could not send schedule: " + e);
            });
        }
      } else {
        this.trackEvent("Cancelled SportsEngine Export", {
          schedule: schedule,
        });
        this.makeToast("info", "Action Cancelled - Schedule not sent");
      }
    },
    getSportFromID(id) {
      this.sayDev("Get Sport from ID: " + id);
      var result = "Other";
      this.sportIds.forEach(i => {
        if (i.id == id) {
          this.sayDev("Sport from ID " + id + " is " + i.name);
          result = i.name;
        }
      });
      return result;
    },
    getIDFromSport(sport) {
      var result = 27;
      this.sportIds.forEach(i => {
        if (i.name.toLowerCase() == sport.toLowerCase()) {
          result = i.id;
        }
      });
      return result;
    },
    invertColor(hex) {
      var hexcolor = hex;
      // this.sayDev("Invert Color: " + hex)
      if (hex == "grey") {
        return "white";
      }
      if (hex == "black") {
        return "white";
      }
      if (!hex.includes("#")) {
        return "black";
      }
      // If a leading # is provided, remove it
      if (hexcolor.slice(0, 1) === "#") {
        hexcolor = hexcolor.slice(1);
      }

      // If a three-character hexcode, make six-character
      if (hexcolor.length === 3) {
        hexcolor = hexcolor
          .split("")
          .map(function(hex) {
            return hex + hex;
          })
          .join("");
      }

      // Convert to RGB value
      let r = parseInt(hexcolor.substr(0, 2), 16);
      let g = parseInt(hexcolor.substr(2, 2), 16);
      let b = parseInt(hexcolor.substr(4, 2), 16);

      // Get YIQ ratio
      let yiq = (r * 299 + g * 587 + b * 114) / 1000;

      // Check contrast
      return yiq >= 128 ? "black" : "white";
    },

    padZero(str, len) {
      len = len || 2;
      var zeros = new Array(len).join("0");
      return (zeros + str).slice(-len);
    },
    identifyUser() {
      if (this.currentUser) {
        var user = this.currentUser;
        var x = {
          first: user.first,
          last: user.last,
          upgraded: user.upgraded,
          timezone: user.timezone,
          timezone_offset: user.timezone_offset,
          full_name: user.first + " " + user.last,
          email: user.email,
          created_at: user.created_at,
          locale: user.locale,
        };
        this.sayDev("Identify User: ", x);
        this.sayDev("FD: " + this.currentUser.first_day);
        window.analytics.identify(user.id, x);
      }
    },
    trackEvent(name, properties) {
      if (window.analytics) {
        // this.sayDev("✅ Track Event: " + name, properties)
        window.analytics.track(name, properties);
      }
    },
    getCompliment(color) {
      if (color == "grey" || color == "black") {
        return {
          color: "#FFFFFF",
          text: "#FFFFFF",
        };
      } else if (this.primaryPallette.indexOf[color] > -1) {
        return {
          color: this.secondaryPallette[this.primaryPallette.indexOf[color]],
          text: "#FFFFFF",
        };
      } else if (this.secondaryPallette.indexOf[color] > -1) {
        return {
          color: this.primaryPallette[this.secondaryPallette.indexOf[color]],
          text: "#000000",
        };
      }
    },
    getSeasonDivision(id) {
      // console.log("⭐️ GSD: " + id)
      var division = {};
      this.$store.getters.currentSeason.divisions.forEach(d => {
        // console.log(d.name + " (" + d.id + ")")
        if (d.id == id) {
          // this.sayDev("Found " + d.name)
          division = d;
        }
      });
      return division;
    },
    getSeasonTeam(id) {
      console.log("⭐️ GST: " + id);
      var team = {};
      this.$store.getters.currentSeason.teams.forEach(d => {
        console.log(d.name + " (" + d.id + ")");
        if (d.id == id) {
          // this.sayDev("Found " + d.name)
          team = d;
        }
      });
      console.log("Return ", team);
      return team;
    },
    trueRandomHex() {
      return "#" + ("00000" + ((Math.random() * (1 << 24)) | 0).toString(16)).slice(-6);
    },
    randomPrimaryHex(index) {
      // var arr = ["#307D7E", "#2B1B17", "#25383C", "#3D3C3A", "#4863A0", "000080", "#6960EC", "#659EC7", "#38ACEC",
      // "#3EA99F", "#008080", "#78866B", "#617C58", "#347235", "#FBB117", "#806517", "#493D26", "#C35817", "#F75D59", "#7E3517", "#800517", "#7D0541", "#7F525D", "#4B0082", "#C48189", "#8C001A", "#C04000"]
      var arr = [
        "#E90038",
        "#AD1457",
        "#8E24AA",
        "#4527A0",
        "#7E57C2",
        "#1565C0",
        "#03A9F4",
        "#00B8D4",
        "#00796B",
        "#388E3C",
        "#8BC34A",
        "#AFB42B",
        "#FDD835",
        "#FFB300",
        "#F57C00",
        "#F4511E",
        "#795548",
        "#7B7565",
        "#757575",
        "#607D8B",
        "#AEEA00",
        "#2962FF",
        "#00E5FF",
        "#00BFA5",
        "#00C853",
        "#F50057",
      ];
      if (index) {
        return arr[index];
      } else {
        return arr[Math.floor(Math.random() * arr.length)];
      }
    },
    randomSecondaryHex(index) {
      // var arr = ["#307D7E", "#2B1B17", "#25383C", "#3D3C3A", "#4863A0", "000080", "#6960EC", "#659EC7", "#38ACEC",
      // "#3EA99F", "#008080", "#78866B", "#617C58", "#347235", "#FBB117", "#806517", "#493D26", "#C35817", "#F75D59", "#7E3517", "#800517", "#7D0541", "#7F525D", "#4B0082", "#C48189", "#8C001A", "#C04000"]
      var arr = [
        "#FF8A80",
        "#F8BBD0",
        "#E1BEE7",
        "#B39DDB",
        "#9FA8DA",
        "#90CAF9",
        "#B3E5FC",
        "#80DEEA",
        "#B2DFDB",
        "#A5D6A7",
        "#DCEDC8",
        "#E6EE9C",
        "#FFF59D",
        "#FFE082",
        "#FFCC80",
        "#FFAB91",
        "#D7CCC8",
        "#BCAAA4",
        "#BDBDBD",
        "#B0BEC5",
        "#CCFF90",
        "#80D8FF",
        "#18FFFF",
        "#64FFDA",
        "#69F0AE",
        "#FF80AB",
      ];
      if (index) {
        return arr[index];
      } else {
        return arr[Math.floor(Math.random() * arr.length)];
      }
    },
    doLightbox(url) {
      var x = url;
      if (this.currentUser) {
        x += "?name=" + this.currentUser.name + "&email=" + this.currentUser.email;
      }
      this.sayDev("DoLightbox", x);
      this.trackEvent("Opened Video", { url: url });
      lity(x);
    },
    po(str, text) {
      this.sayDev(text);
      this.sayDev(JSON.stringify(str, undefined, 2));
    },
    dynamicSort(property) {
      this.sayDev("DynamicSort: " + property);
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function(a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    reconnectSportsengine() {
      var url = this.baseURL || "https://app.cactusware.com/oauth/callback";
      this.sayDev("Base URL: " + this.baseURL);
      this.sayDev("URL: " + url);
      var currentUrl = new URL(window.location.href);
      var returnPath = currentUrl.searchParams.get("return");
      var link =
        "https://user.sportngin.com/oauth/authorize?response_type=code&client_id=" +
        process.env.VUE_APP_SE_CLIENT +
        "&redirect_uri=" +
        url +
        "/oauth/callback";
      if (returnPath) {
        link += "?return=" + encodeURIComponent(returnPath);
      }
      window.location.href = link;
    },
    startSportsEngineAuth() {
      if (this.seConnected) {
        this.goRouter("/sportsengine");
        return;
      }
      this.trackEvent("Started Connect SportsEngine", {});
      this.reconnectSportsengine();
    },
    getURLParam(str) {
      var x = new URLSearchParams(window.location.search);
      return x.get(str);
    },
    makeToast(level, title, text, duration) {
      this.$toast.add({ severity: level, summary: this.$t(title), detail: text, life: duration || 5000 });
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    formatAMPM(date) {
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    capitalizeFirstLetter: str => str.charAt(0).toUpperCase() + str.slice(1),
    dayFromNumber(num) {
      switch (num) {
        case 0:
          return this.$t("Sunday");
        case 1:
          return this.$t("Monday");
        case 2:
          return this.$t("Tuesday");
        case 3:
          return this.$t("Wednesday");
        case 4:
          return this.$t("Thursday");
        case 5:
          return this.$t("Friday");
        case 6:
          return this.$t("Saturday");
        default:
          return "";
      }
    },
    focusInput(id, flash) {
      setTimeout(() => {
        var x = document.getElementById(id);
        if (x) {
          x.focus();
        }
      }, 300);
    },
    leaderboardStatsByDivision(allGames, scoringSystem = {}) {
      const gamesByDivision = {};
      allGames.forEach(g => {
        (gamesByDivision[g.home.division_id] = gamesByDivision[g.home.division_id] || []).push(g);
        if (g.home.division_id !== g.visitor.division_id) {
          (gamesByDivision[g.visitor.division_id] = gamesByDivision[g.visitor.division_id] || []).push(g);
        }
      });

      console.log("[Debug] gamesByDivision:", gamesByDivision);

      return Object.entries(gamesByDivision)
        .filter(dgs => dgs[0] !== "undefined")
        .map(([divisionId, games]) => {
          const teams = games
            .map(game => (game.home.division_id === divisionId ? game.home.name : game.visitor.name))
            .filter((value, index, array) => array.indexOf(value) === index);

          let divisionName = "";

          if (games[0].home.division_id === divisionId) {
            divisionName = games[0].home.division && games[0].home.division.name;
          } else {
            divisionName = games[0].visitor.division && games[0].visitor.division.name;
          }

          return this.calculateTeamsPoints(teams, games, scoringSystem, divisionName);
        });
    },
    gamesLeaderboardStats(games, scoringSystem, divisionName = "") {
      const teams = games
        .map(game => [game.home_name, game.visitor_name])
        .flat()
        .filter((value, index, array) => array.indexOf(value) === index)
        .filter(t => t !== "TBD");

      return this.calculateTeamsPoints(teams, games, scoringSystem, divisionName);
    },
    calculateTeamsPoints(teamNames, games, scoringSystem, divisionName = "") {
      const teamPoints = teamNames.map(team => {
        const gamesPlayed = games.filter(game => {
          return (
            (game.home_name === team || game.visitor_name === team) &&
            game.home_score !== null &&
            game.visitor_score !== null
          );
        });

        const homeGames = gamesPlayed.filter(game => game.home_name === team);
        const homeGamesWon = homeGames.filter(game => game.home_score > game.visitor_score);
        const homeGamesLoss = homeGames.filter(game => game.home_score < game.visitor_score);
        const homeTieGames = homeGames.filter(game => game.home_score === game.visitor_score);

        const visitorGames = gamesPlayed.filter(game => game.visitor_name === team);
        const visitorGamesWon = visitorGames.filter(game => game.visitor_score > game.home_score);
        const visitorGamesLoss = visitorGames.filter(game => game.visitor_score < game.home_score);
        const visitorTieGames = visitorGames.filter(game => game.visitor_score === game.home_score);

        const allGamesWon = [...homeGamesWon, ...visitorGamesWon];
        const allGamesWonIds = allGamesWon.map(game => game.id);
        const allGamesTie = [...homeTieGames, ...visitorTieGames];
        const allGamesTieIds = allGamesTie.map(game => game.id);
        const allGamesLoss = gamesPlayed.filter(
          game => allGamesWonIds.indexOf(game.id) === -1 && allGamesTieIds.indexOf(game.id) === -1,
        );

        const gamesCounter = gamesPlayed.length;
        const winCounter = homeGamesWon.length + visitorGamesWon.length;
        const tieConuter = allGamesTie.length;
        const lossCounter = gamesCounter - winCounter - tieConuter;
        const overtimeWinCounter = allGamesWon.filter(game => game.overtime).length;
        const overtimeLossCounter = allGamesLoss.filter(game => game.overtime).length;

        const homeTiePoints = homeTieGames.length * 0.5;
        const homeWon = homeGamesWon.length + homeTiePoints;
        const homeLoss = homeGamesLoss.length + homeTiePoints;
        const homeCounter = `${homeWon}-${homeLoss}`;

        const awayTiePoints = visitorTieGames.length * 0.5;
        const awayWon = visitorGamesWon.length + awayTiePoints;
        const awayLoss = visitorGamesLoss.length + awayTiePoints;
        const awayCounter = `${awayWon}-${awayLoss}`;

        const teamStats = {
          name: team,
          gamesPlayed: gamesCounter,
          win: winCounter,
          loss: lossCounter,
          tie: tieConuter,
          win_pct: gamesCounter ? (winCounter / gamesCounter).toFixed(3) : "0.000",
          overtime_win: overtimeWinCounter,
          overtime_loss: overtimeLossCounter,
          home: homeCounter,
          away: awayCounter,
        };

        teamStats.points = this.calculatePoints(teamStats, scoringSystem);
        if (divisionName) teamStats.divisionName = divisionName;

        return teamStats;
      });

      return teamPoints.sort((a, b) => b.points - a.points).map((team, index) => ({ ...team, rank: index + 1 }));
    },
    buildEmptyGameStatRow(teamName) {
      return {
        name: teamName,
        gamesPlayed: 0,
        win: 0,
        loss: 0,
        tie: 0,
        win_pct: "0.000",
        overtime_win: 0,
        overtime_loss: 0,
        home: "0-0",
        away: "0-0",
        points: 0,
      };
    },
    calculatePoints(stats, scoringSystem) {
      const winPoints = stats.win * scoringSystem.win_points - stats.overtime_win * scoringSystem.win_points;
      const lossPoints = stats.loss * scoringSystem.loss_points;
      const tiePoints = stats.tie * scoringSystem.tie_points;
      const overtimeWinPoints = stats.overtime_win * scoringSystem.overtime_win_points;
      const overtimeLossPoints = stats.overtime_loss * scoringSystem.overtime_loss_points;

      return winPoints + lossPoints + tiePoints + overtimeWinPoints + overtimeLossPoints;
    },
    filterScheduleItems(items, teams, divisions, venues, surfaces) {
      // this.sayDev("FSI", arguments)
      var valid_teams = [];
      items.forEach(i => {
        // Check teams
        if (
          teams &&
          ((teams.length > 0 && i.game && teams.includes(i.game.home.id)) ||
            teams.includes(i.game.visitor.id) ||
            i.game.tbd)
        ) {
          valid_teams.push(i);
        }
      });
      var valid_divisions = [];
      valid_teams.forEach(i => {
        // Check division
        if (divisions && divisions.length > 0 && i.game && divisions.includes(i.game.division_id)) {
          valid_divisions.push(i);
        }
      });
      var valid_surfaces = [];
      valid_divisions.forEach(i => {
        if (surfaces && surfaces.length > 0 && i.timeslot && i.timeslot && surfaces.includes(i.timeslot.surface.id)) {
          valid_surfaces.push(i);
        }
      });
      var valid_venues = [];
      valid_surfaces.forEach(i => {
        // Check division
        if (venues && venues.length > 0 && i.timeslot && venues.includes(i.timeslot.venue.id)) {
          valid_venues.push(i);
        }
      });
      // this.sayDev(`✅ Results: ${valid_venues.length}`)
      this.sayDev(`💥 Filter ${items.length} --> ` + valid_venues.length);
      return valid_venues;
    },
    selectDateWithinRange(d, s, e) {
      // this.sayDev(d +"\n\n")
      var date = this.$moment(d);
      var start = this.$moment(new Date(s));
      var end = this.$moment(new Date(e));
      // this.sayDev(start.utc().format() + " 🌸🌸 " + end.utc().format())
      var rs = start;
      var re = end;
      // console.log("Check " + date + " is between " + start + " and " + end)
      // console.log("Between: " + date.isBetween(rs, re))
      // console.log("SameStart: " + date.isSame(rs))
      // console.log("SameEnd: " + date.isSame(re))
      var good = date.isBetween(rs, re) || date.isSame(rs) || date.isSame(re);
      // this.sayDev("----> " + good)
      return good;
    },
    dateWithinRange(d, s, e) {
      console.log("\n\n\n 💙");
      // this.sayDev(d +"\n\n")
      // console.log(d, s, e)
      var date = this.$moment(d);
      var start = this.$moment(new Date(s));
      var end = this.$moment(new Date(e)).add(1, "d");
      // console.log(start.utc().format() + " 🌸 " + end.utc().format())
      var rs = start.endOf("day");
      var re = end.endOf("day");
      // this.sayDev(start.format() + " 🌸🌸 " + end.format())
      // var rs = start
      // var re = end
      // console.log("Check " + date.format() + " is between " + rs.format() + " and " + re.format())
      // console.log("Between: " + date.isBetween(rs, re))
      // console.log("SameStart: " + date.isSame(rs))
      // console.log("SameEnd: " + date.isSame(re))
      var good = date.isBetween(rs, re) || date.isSame(rs) || date.isSame(re);
      // this.sayDev("----> " + good)
      return good;
    },
    filterTimeslots(
      items,
      teams,
      divisions,
      venues,
      multi,
      games,
      timeslots,
      schedule_id,
      surfaces,
      start,
      end,
      practiceSlots,
      gameSlots,
      includePractices,
    ) {
      if (this.isDebug) {
        this.sayDev(`💥 Filtering ${items.length} TIMESLOTS on: `);
        // if (teams.length) { this.sayDev("- - - Teams: " + teams.toString()) }
        // if (start) { this.sayDev("- - - From: " + start + " to " + end) }
        // if (divisions.length) {this.sayDev("- - - Divisions: " + divisions.toString())}
        // if (venues.length) {this.sayDev("- - - Venues: " + venues.toString()) }
        // if (surfaces && surfaces.length) {this.sayDev("- - - Surfaces: " + surfaces.toString()) }
        // if (multi) {this.sayDev("- - - Multi: " + multi)}
        // if (gameSlots || practiceSlots) { this.sayDev("- - - Game / Practice Slots: " + gameSlots + " / " + practiceSlots) }
        this.sayDev("🍌 Filter Timeslots: ");
        this.sayDev(" -- teams: " + teams);
        this.sayDev(" -- divisions: " + divisions);
        this.sayDev(" -- venues: " + venues);
        this.sayDev(" -- multi: " + multi);
        this.sayDev(" -- games: " + games);
        this.sayDev(" -- timeslots: " + timeslots);
        this.sayDev(" -- schedule_id: " + schedule_id);
        this.sayDev(" -- surfaces: " + surfaces);
        this.sayDev(" -- start: " + start);
        this.sayDev(" -- end: " + end);
        this.sayDev(" -- practiceSlots: " + practiceSlots);
        this.sayDev(" -- gameSlots: " + gameSlots);
        this.sayDev(" -- includePractices: " + includePractices);
      }
      var ms = false;
      var me = false;
      if (start) {
        ms = this.$moment(start).subtract("1", "day");
        this.sayDev("MS: ", ms);
      }
      if (end) {
        me = this.$moment(end).add("1", "day");
        this.sayDev("MS: ", me);
      }
      this.sayDev("Pre-divisions: " + items.length);
      var valid_divisions = [];
      items.forEach(i => {
        // Check division
        var good = false;
        if ((games && i.has_game && (includePractices || !i.game.is_practice)) || (timeslots && !i.has_game)) {
          if (!multi) {
            var x = this.arrayEquals(divisions, i.divisions);
            var z = !i.divisions || (i.divisions.length == 1 && divisions.includes(i.divisions[0]));
            // this.sayDev("nm", x, z)
            if (z) {
              good = true;
            }
          } else {
            if (!i.divisions.length || i.divisions.length == 0) {
              good = true;
            } else if (i.divisions) {
              var commonElements = i.divisions.filter(function(e) {
                return divisions.indexOf(e) > -1;
              });
              // this.sayDev("check divs...." + commonElements, i.divisions, divisions)
              if (commonElements[0]) {
                // if (this.isDebug){ console.log("✅ Division Valid " + i.id)}
                good = true;
              } else {
                // if (this.isDebug) { console.log("🔴 No common elements", divisions, i.divisions)}
              }
            }
          }
        }

        if (includePractices && i.game && i.game.is_practice) {
          good = true;
        }
        if (good && i.game) {
          console.log("Check teams: " + teams.length);
          good = teams.includes(i.game.home_id) || teams.includes(i.game.visitor_id);
          good = good && divisions.includes(i.game.division_id);
        }
        if (good) {
          if (includePractices && i.game && i.game.is_practice) {
            good = true;
            this.sayDev("Practice ✅");
          }
          if (!practiceSlots && !i.has_game && i.is_practice && !i.is_game) {
            good = false;
            this.sayDev("🔴 Not practice ", i);
          }

          if (!gameSlots && !i.has_game && i.is_game && !i.is_practice) {
            good = false;
            this.sayDev("🔴 Not game ", i);
          }

          if (!gameSlots && !practiceSlots && !i.is_game) {
            good = false;
            this.sayDev("🔴 Not game slots ", i);
          }
        }

        if (good) {
          if (start) {
            good = good && this.$moment(i.start).isAfter(ms);
            if (!good) {
              this.sayDev("🔴 Failed start check --> " + i.start + " is not after " + start);
            }
          }
          if (good && end) {
            good = good && this.$moment(i.start).isBefore(me);
            if (!good) {
              this.sayDev("🔴 Failed end check --> " + i.start + " is not before " + end);
            }
          }

          if (good) {
            valid_divisions.push(i);
          }
        }
      });
      this.sayDev("Pre-Venues: " + valid_divisions.length);

      // this.sayDev("ValidDivs: " + valid_divisions.length)
      var valid_venues = [];
      valid_divisions.forEach(i => {
        // Check division
        if (venues.length > 0 && venues.includes(i.venue_id)) {
          valid_venues.push(i);
        }
      });
      this.sayDev("Post-Venues: " + valid_venues.length);
      var valid_surfaces = [];
      valid_venues.forEach(i => {
        if (surfaces.length > 0 && surfaces.includes(i.surface_id)) {
          valid_surfaces.push(i);
        }
      });
      this.sayDev("Post-Surfaces: " + valid_surfaces.length);

      var valid_items = [];
      if (true || (practiceSlots && gameSlots)) {
        valid_items = valid_surfaces;
      } else {
        this.sayDev("Practice or Game", practiceSlots, gameSlots);
        valid_surfaces.forEach(i => {
          this.sayDev("Slot: ", i.is_practice, i.is_game);
          if (practiceSlots && i.is_practice) {
            valid_items.push(i);
          } else if (gameSlots && i.is_game) {
            valid_items.push(i);
          } else if (timeslots && !i.has_game) {
            this.sayDev("Timeslots, not game, push");
            valid_items.push(i);
          } else {
            this.sayDev("Dont push...", i);
          }
        });
      }

      this.sayDev(`✅ Results: ${valid_items.length}`);
      // var valid_items = []
      // valid_surfaces.forEach((i)=> {
      // 	if (include)
      // })

      if (schedule_id) {
        var valid_schedules = [];
        valid_items.forEach(i => {
          if ((i.has_game && i.schedule_id == schedule_id) || !i.has_game) {
            valid_schedules.push(i);
          }
        });
        return valid_schedules;
      } else {
        return valid_items;
      }
    },
    getArrayObjectID(arr, id) {
      var x = false;
      if (!arr || !id) {
        return false;
      }
      arr.forEach(item => {
        this.sayDev(item.id + " / " + id);
        if (item.id == id) {
          x = item;
        }
      });
      return x;
    },
    arrayEquals(a, b) {
      return Array.isArray(a) && Array.isArray(b) && a.length === b.length && a.every((val, index) => val === b[index]);
    },
    refreshLeagueInformation(path) {
      this.$store.dispatch("getLeagueInformation");
      if (path) {
        this.goRouter(path);
      }
    },
    switchOrganization(organization) {
      if (organization) {
        api.switchOrganization(organization.id).then(response => {
          //this.$store.dispatch("setCurrentOrganization", organization);
          this.refreshLeagueInformation("/");
        });
        console.log("🏀 Switching to Organization successfully", organization.name);
      }
    },
    setCurrentLeagueSeasonId(league_id, season_id) {
      this.sayDev("🔴 SCLSID", league_id, season_id);
      var foundSeason = false;
      api
        .getLeagueInformation()
        .then(response => {
          this.$store.commit("setLeagueInformation", response.data.leagues);
          this.$store.commit("setOrganizationInformation", response.data.organizations);
          this.$store.commit("setCurrentOrganization", response.data.current_organization);
          response.data.leagues.forEach(league => {
            if (league.id == league_id) {
              // this.sayDev("Found league")
              this.$store.commit("setCurrentLeague", league);
              if (!season_id) {
                this.$store.commit("setCurrentSeason", league.seasons[0]);
              } else {
                league.seasons.forEach(season => {
                  if (season.id == season_id) {
                    foundSeason = true;
                    // this.sayDev("Found season")
                    this.$store.commit("setCurrentSeason", season);
                  }
                });
              }
            }
          });
          this.$forceUpdate();
        })
        .catch(e => {
          this.sayDev("Error", e);
        });
    },
    proceed(path) {
      this.sayDev("⭐️ Proceed: " + path);
      var r = this.getURLParam("return");
      if (r && r != "/") {
        this.sayDev("Return to " + r);
        this.goRouter(r);
        return;
      }
      this.goRouter(path);
    },
    goRouter(path) {
      this.sayDev("GoRouter: " + path);
      this.$router.push(path).catch(e => {
        // this.sayDev("Caught router error: ", e)
      });
    },
    removeBadCharacters(str) {
      // https://gist.github.com/terrancesnyder/1345094
      let regex = /[^\w\s\u3000-\u303F\u3040-\u309F\u30A0-\u30FF\u4E00-\u9FAF\uFF00-\uFFEF]/g;
      return str.replace(regex, "");
    },
    resetUser() {
      const currentLocale = JSON.parse(localStorage.getItem("locale")) || 'en';

      localStorage.clear();
      localStorage.removeItem("user");
      localStorage.removeItem("locale");
      localStorage.removeItem("currentOrganization");
      localStorage.removeItem("currentLeague");
      localStorage.removeItem("currentSeason");
      this.$store.dispatch("signOut").then(() => {
        this.sayDev("Signed out....");
        var cookies = document.cookie.split(";");
        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
        localStorage.clear();
        this.goRouter(`/${currentLocale}/sign-in`);
      });
    },
  },
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  data: function() {
    return {
      checkInterval: null,
    };
  },
  watch: {
    "$route.path"(to, from) {
      if (to != window.lastRoute) {
        window.lastRoute = from;
        this.sayDev("✨ " + window.lastRoute);
      }
    },
  },
  created() {
    if (!window.location.href.includes("localhost") && !window.location.href.includes("sentry=0")) {
      Sentry.init({
        Vue: Vue,
        dsn: process.env.VUE_APP_SENTRY_DNS,
        integrations: [new Integrations.BrowserTracing()],
        environment: process.env.VUE_APP_SENTRY_ENV || "staging",
        // We recommend adjusting this value in production, or using tracesSampler
        // for finer control
        tracesSampleRate: 0.2,
      });
      this.sayDev("💥 Sentry Initialized");
    } else {
      this.sayDev("🔴 Skip Sentry");
    }
  },
  mounted() {
    // TODO
    if (this.currentUser) {
      if (window.location.href.includes("switched=1")) {
        alert("Switched successfully - remember to sign out!");
      }
      this.sayDev("CU Exists");
      api
        .checkSession()
        .then(response => {
          this.identifyUser();
          this.setCookie("dsuid", this.currentUser.id, 500);
        })
        .catch(e => {
          this.sayDev("Caught auth error: ", e);
          this.resetUser();
        });
    } else {
      if (
        !window.location.href.includes("wizard") &&
        !window.location.href.includes("embed") &&
        !window.location.href.includes("sign") &&
        !window.location.href.includes("callback") &&
        !window.location.href.includes("password") &&
        !window.location.href.includes("invitation") &&
        !window.location.href.includes("confirmation") &&
        this.$route.name !== "PublicHome" &&
        this.$route.name !== "PublicTeam" &&
        this.$route.name !== "PublicStandings" &&
        this.$route.name !== "PublicSchedules" &&
        this.$route.name !== "PublicScores" &&
        !this.$route.meta.props.public
      ) {
        this.goRouter("/sign-in");
      }
    }
    window.analytics.page();
    window.lastRoute = this.$route.path;
  },
}).$mount("#app");
